<template>
  <div class="code-block-container">
    <h2 class="code-block-title">
      {{ attachmentContent.name }} {{ attachmentContent.language }}
    </h2>
    <div class="code-content">
      <code> {{ attachmentContent.content }}</code>
    </div>
  </div>
</template>
<script>
export default {
  name: 'code-block-attachment',
  computed: {
    attachmentContent() {
      return JSON.parse(this.attachmentDetails?.content);
    }
  },

  props: { attachmentDetails: Object }
};
</script>
<style scoped>
.code-block-container {
  background: white;
  padding: 16px;
  border-radius: 4px;
  word-break: break-word;
  overflow-x: auto;
}
.code-block-title {
  user-select: text;
}
.code-content {
  padding: 8px;
  border: 1px solid gray;
  margin-top: 8px;
}
.code-content code {
  background: inherit;
  color: initial;
  white-space: pre-wrap;
}
</style>
